/*
 * @Author: 吴文洁 
 * @Date: 2019-10-17 18:13:23 
 * @Last Modified by: 吴文洁
 * @Last Modified time: 2019-10-17 18:13:48
 * @Description: 获取共用的计算样式
 */

const getInputStyle = (color: string, backgroundColor: string) => {
  return {
    color,
    backgroundColor,
  }
}

export {
  getInputStyle,
} 